import {
    cloneElement,
    memo,
    type ReactElement,
    type ReactNode,
    useMemo,
} from 'react';

import { Flex, Space, Typography } from 'antd';

import {
    useViewerEmail,
    useViewerFullName,
    ViewerAvatar,
} from '@/entities/viewer';

import cls from './header-menu-content.module.css';

interface HeaderMenuContentProps {
    originNode: ReactNode;
}

export const HeaderMenuContent = memo((props: HeaderMenuContentProps) => {
    const { originNode } = props;

    const viewerFullName = useViewerFullName();
    const viewerEmail = useViewerEmail();

    const menuProps = useMemo(
        () => ({
            style: {
                boxShadow: 'none',
                backgroundColor: 'var(--header-menu-bg)',
            },
        }),
        [],
    );

    return (
        <div className={cls.root}>
            <div className={cls.info}>
                <Space size={12}>
                    <ViewerAvatar />
                    <Flex vertical>
                        <Typography.Text>{viewerFullName}</Typography.Text>
                        <Typography.Text className={cls.email}>
                            {viewerEmail}
                        </Typography.Text>
                    </Flex>
                </Space>
            </div>
            {cloneElement(originNode as ReactElement, menuProps)}
        </div>
    );
});

HeaderMenuContent.displayName = 'HeaderMenuContent';
